'use strict';

$(function() {
    var runamim = true;

    if (runamim) {
        if (typeof modAnimationRun === 'undefined') {
            return;
        }
        if (!$( '.bganim-container' ).length) {
            return;
        }
        const anim = new modAnimationRun({
            groups: bgscene.groups,
            animations: bgscene.animations,

            animationContainer: '.preview-c',

        }, $( '.bganim-container' ).get(0) );

        if (typeof VarMgr !== 'undefined') {
            if (VarMgr.get('PAUSE_ANIM')) {
                anim.togglePause();
            }
            VarMgr.set('globalBgAnim', anim);
        } else {
            if (typeof PAUSE_ANIM !== 'undefined' && PAUSE_ANIM) {
                anim.togglePause();
            }
        }
    }
});